// extracted by mini-css-extract-plugin
export var item = "TXr1Kwuz6LdAlnVgi9CA";
export var item_ethereum = "FiO6J3m9rHoiBye2KBIr";
export var item_waves = "xYt8xxebmKk0InYO3AvS";
export var root = "dgQhGc724XxM8u4OPP12";
export var text = "WPhCZD6iQmbHa6hcPAJU";